import React from 'react'
import PropTypes from 'prop-types'
import {Box, VStack, useStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'
import useNavigation from '@salesforce/retail-react-app/app/hooks/use-navigation'

const ProductPromotionCallouts = ({product}) => {
    const styles = useStyleConfig('ProductPromotionCallouts')
    const hasCalloutMessage = (promo) => !!promo.calloutMsg
    const productPromotions = product?.productPromotions || product?.c_promotions
    const calloutPromotions = productPromotions.filter(hasCalloutMessage)

    const navigate = useNavigation()
    return (
        <VStack gap="15px" display={calloutPromotions?.length ? 'block' : 'none'}>
            {calloutPromotions?.map((promotion, index) => (
                <Box
                    key={index}
                    data-id={promotion?.promotionId}
                    onClick={(e) => {
                        if (
                            e.target.href &&
                            e.target.tagName === 'A' &&
                            e.target.className?.indexOf('external-redirection') === -1
                        ) {
                            e.preventDefault()
                            navigate(
                                e.target.href?.split('.com')?.[1] || e.target.href?.split('.com')
                            )
                        }
                    }}
                    dangerouslySetInnerHTML={{__html: promotion.calloutMsg}}
                    {...styles.container}
                />
            ))}
        </VStack>
    )
}

ProductPromotionCallouts.propTypes = {
    product: PropTypes.object
}

export default ProductPromotionCallouts
